import React from 'react';
import { Wallet, RefreshCw, LogOut } from 'lucide-react';
import { setToken } from '@/lib/api';

const logAndReset = () => {
  setToken(null);
  window.location.href = '/login';
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] unexpected error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen w-full grid place-items-center bg-[#090D16] text-white px-6">
          <div className="w-full max-w-md text-center space-y-6">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 grid place-items-center shadow-lg shadow-emerald-500/30">
              <Wallet className="h-7 w-7 text-white" />
            </div>
            <div className="space-y-2">
              <h1 className="font-heading text-2xl font-bold tracking-tight">Ops! Algo deu errado.</h1>
              <p className="text-white/60 text-sm leading-relaxed">
                Ocorreu um erro inesperado na interface. Recarregue a página ou volte para a tela de login.
              </p>
              {this.state.error && (
                <pre className="mt-4 overflow-x-auto rounded-md bg-white/5 border border-white/10 p-3 text-left text-xs text-rose-300 font-mono">
                  {String(this.state.error)}
                </pre>
              )}
            </div>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center justify-center gap-2 h-11 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-medium transition-colors"
              >
                <RefreshCw className="h-4 w-4" />
                Recarregar
              </button>
              <button
                onClick={logAndReset}
                className="inline-flex items-center justify-center gap-2 h-11 rounded-lg border border-white/15 hover:bg-white/5 text-white/80 font-medium transition-colors"
              >
                <LogOut className="h-4 w-4" />
                Voltar ao login
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}